import bindAll from 'lodash.bindall';
import PropTypes from 'prop-types';
import React from 'react';
import { defineMessages, injectIntl, intlShape } from 'react-intl';
import VM from 'scratch-vm';

import backdropLibraryContent from '../lib/libraries/backdrops.json';
import myBackdrops from "../lib/libraries/my/backdrops.json"
import backdropTags from '../lib/libraries/backdrop-tags';
import myBackdropTags from '../lib/libraries/my/backdrop-tags';
import LibraryComponent from '../components/library/library.jsx';

const messages = defineMessages({
    libraryTitle: {
        defaultMessage: 'Choose a Backdrop',
        description: 'Heading for the backdrop library',
        id: 'gui.costumeLibrary.chooseABackdrop'
    }
});


class BackdropLibrary extends React.Component {
    constructor(props) {
        super(props);
        bindAll(this, [
            'handleItemSelect'
        ]);
    }
    handleItemSelect(item) {
        // {//用户自定义的背景 格式如下 区别就在rawURL 有的是md5ext 有的是rawURL
        //     "name": "test战场",
        //     "tags": ["室外"],
        //     "assetId": "ad39925c16674a1fa8c2b29ddbe4cdba",
        //     "bitmapResolution": 1,
        //     "dataFormat": "svg",//经过测试 这种方法会导致sb3无法导入到别的平台
        //     "rawURL": "zhouwei/ad39925c16674a1fa8c2b29ddbe4cdba.svg",
        //     "rotationCenterX": 240,
        //     "rotationCenterY": 180
        // },
        const vmBackdrop = {
            name: item.name,
            rotationCenterX: item.rotationCenterX,
            rotationCenterY: item.rotationCenterY,
            bitmapResolution: item.bitmapResolution,
            skinId: null
        };
        // Do not switch to stage, just add the backdrop
        // if (typeof item.md5ext === 'string' && item.md5ext.length > 0) {
        this.props.vm.addBackdrop(item.md5ext, vmBackdrop);
        // } else {// 从cos下载
        //     this.props.vm.addBackdrop(item.rawURL, vmBackdrop);
        // }

    }
    render() {
        return (
            <LibraryComponent
                data={myBackdrops}
                id="backdropLibrary"
                tags={myBackdropTags}
                title={this.props.intl.formatMessage(messages.libraryTitle)}
                onItemSelected={this.handleItemSelect}
                onRequestClose={this.props.onRequestClose}
            />
        );
    }
}

BackdropLibrary.propTypes = {
    intl: intlShape.isRequired,
    onRequestClose: PropTypes.func,
    vm: PropTypes.instanceOf(VM).isRequired
};

export default injectIntl(BackdropLibrary);



// [
//     {
//         "name": "冰原赛道",
//         "md5": "3f10473286a044888d7438be2558190a.png",
//         "type": "sprite",
//         "tags": ["场景"],
//         "info": [0, 4, 1],
//         "json": {
//             "name": "冰原赛道",
//             "isStage": false,
//             "blocks": {},
//             "variables": {},
//             "sounds": [],
//             "costumes": [
//                 {
//                     "name": "下载 (1)",
//                     "baseLayerID": -1,
//                     "baseLayerMD5": "b958a0042bd74e4fa8a82e2d41f9531a.png",
//                     "bitmapResolution": 1,
//                     "rotationCenterX": 0,
//                     "rotationCenterY": 0,
//                     "dataFormat": "png",
//                     "costumeName": "下载 (1)",
//                     "assetId": "b958a0042bd74e4fa8a82e2d41f9531a"
//                 },
//                 {
//                     "name": "下载",
//                     "baseLayerID": -1,
//                     "baseLayerMD5": "47b462e2f61849be924e5da3d3cd601f.png",
//                     "bitmapResolution": 1,
//                     "rotationCenterX": 0,
//                     "rotationCenterY": 0,
//                     "dataFormat": "png",
//                     "costumeName": "下载",
//                     "assetId": "47b462e2f61849be924e5da3d3cd601f"
//                 }
//             ],
//             "currentCostumeIndex": 0,
//             "x": -20,
//             "y": -38,
//             "scale": 1,
//             "direction": 90,
//             "rotationStyle": "don't rotate",
//             "isDraggable": false,
//             "visible": true,
//             "spriteInfo": {}
//         }
//     },
// ......
// ]

// 我有这样的数组,怎么用python把格式改成
// [
//     {
//         "name": "冰原赛道",
//         "tags": [
//             "场景",
//         ],
//         "isStage": false,
//         "variables": {},
//         "costumes": [
//             {
//                 "assetId": "b958a0042bd74e4fa8a82e2d41f9531a",
//                 "name": "下载 (1)",
//                 "bitmapResolution": 1,
//                 "md5ext": "b958a0042bd74e4fa8a82e2d41f9531a.png",
//                 "dataFormat": "png",
//                 "rotationCenterX": 0,
//                 "rotationCenterY": 0
//             },
//             {
//                 "assetId": "47b462e2f61849be924e5da3d3cd601f",
//                 "name": "下载",
//                 "bitmapResolution": 1,
//                 "md5ext": "47b462e2f61849be924e5da3d3cd601f.png",
//                 "dataFormat": "png",
//                 "rotationCenterX": 0,
//                 "rotationCenterY": 0
//             }
//         ],
//         "sounds": [],
//         "blocks": {}
//     },
// ......
// ]
// 这样的格式
